/*
 * @Author: Liux
 * @Date: 2019-09-25 01:03:42
 * @LastEditor: Liux
 * @LastEditTime: 2020-05-20 17:04:36
 */
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  forwardRef,
  ContentChildren,
  AfterContentInit,
  QueryList,
} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { AdTabMenuItem } from './ad-tab-menu-item';
import { AdTabMenuItemComponent } from './ad-tab-menu-item.component';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: 'ad-tab-menu',
  templateUrl: './ad-tab-menu.component.html',
  styleUrls: ['./ad-tab-menu.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AdTabMenuComponent),
      multi: true,
    },
  ],
})
export class AdTabMenuComponent
  implements OnInit, ControlValueAccessor, AfterContentInit
{
  _dataSource: AdTabMenuItem[];
  _value: string;
  public getActivedItem(): AdTabMenuItem {
    if (this.value !== undefined) {
      const result = this.dataSource.find((item) => item.value === this.value);
      return result;
    }
  }

  @ContentChildren(AdTabMenuItemComponent)
  contentItems: QueryList<AdTabMenuItemComponent>;

  @Input() set dataSource(val) {
    this._dataSource = val;
    this.checkActivedItem();
  }

  get dataSource() {
    return this._dataSource;
  }
  @Input() itemWidth: string;
  @Input() itemCssClass = {};
  @Input() cssClass = {};
  @Output() onMenuClick = new EventEmitter();
  @Output() onMenuOrderChange = new EventEmitter();
  @Input() fullWidth = false;
  selectedMenu: any;

  @Input() canDragAndDrop: boolean = false;
  //#region ngModel

  valueOnChange = (v: any) => {};
  valueOnTouch = () => {};

  writeValue(obj: any): void {
    this._value = obj;
  }
  registerOnChange(fn: any): void {
    this.valueOnChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.valueOnTouch = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    // throw new Error("Method not implemented.");
    // if (this.dataSource) {
    //   this.dataSource.forEach(item => {
    //     item.disabled = true;
    //   });
    // }
  }

  get value() {
    return this._value;
  }

  set value(val) {
    this._value = val;
    this.valueOnChange(val);
  }

  //#endregion
  constructor() {}
  ngAfterContentInit(): void {
    if (this.dataSource) {
      this.checkActivedItem();
    } else if (this.contentItems && this.contentItems.length > 0) {
      const list = this.contentItems.map((item) => {
        return item as AdTabMenuItem;
      });
      this.dataSource = list;
    }
    this.contentItems.changes.subscribe(() => {
      const list = this.contentItems.map((item) => {
        return item as AdTabMenuItem;
      });
      this.dataSource = list;
    });
  }

  getContext(item: AdTabMenuItem) {
    return { item, emitOrderChange: this.emitOrderChange.bind(this) };
  }

  ngOnInit() {}

  checkActivedItem() {
    const result = this.dataSource.find((item) => item.actived);
    if (result) {
      this.value = result.value;
    }
  }

  onItemClick(item) {
    if (!item.disabled) {
      this.value = item.value;
      this.onMenuClick.emit(item);
    }
  }

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousIndex != event.currentIndex) {
      moveItemInArray(
        this._dataSource,
        event.previousIndex,
        event.currentIndex
      );
      //this.onMenuOrderChange.emit(this.dataSource);
      this.emitOrderChange();
    }
  }

  emitOrderChange() {
    this.onMenuOrderChange.emit(this.dataSource);
  }

  trackBy(index: number, item: any) {
    return item.value;
  }
}
